import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const REQUEST = 'SITE_SPONSOR_DETAILS_REQUEST';
export const SUCCESS = 'SITE_SPONSOR_DETAILS_SUCCESS';
export const FAILURE = 'SITE_SPONSOR_DETAILS_FAILURE';

const initialState = {
  loaded: false,
};

export default function siteSponsorDetailsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign({}, state, {
        error: true,
        statusCode: action.data.statusCode,
        ...action.data.json,
      });

    default:
      return state;
  }
}

export function fetchSiteSponsorDetailsRequest(data) {
  return { type: REQUEST, data };
}

export function fetchSiteSponsorDetailsSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchSiteSponsorDetailsFailure(data) {
  return { type: FAILURE, data };
}

export function fetchSiteSponsorDetailsAction(name) {
  return function (dispatch, getState, { Api, i18n }) {
    dispatch(fetchSiteSponsorDetailsRequest());

    const {
      pageConfig: { previewMode, siteId, siteTypePath },
    } = getState();

    return Api()
      .cache(true)
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchSiteSponsorDetails({ siteId, siteTypePath, name })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchSiteSponsorDetailsSuccess(response));
        } else {
          return dispatch(fetchSiteSponsorDetailsFailure(response));
        }
      });
  };
}
